import { render, staticRenderFns } from "./roundQuote.vue?vue&type=template&id=54c873a7&"
import script from "./roundQuote.vue?vue&type=script&lang=js&"
export * from "./roundQuote.vue?vue&type=script&lang=js&"
import style0 from "./roundQuote.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports